import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Sticky from 'react-stickynode'
import { me, showVideos } from '../initial_state'
import {
  BREAKPOINT_EXTRA_SMALL, BREAKPOINT_MEDIUM, BREAKPOINT_SMALL, CX,
} from '../constants'
import Layout from './layout'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import {
  GroupsPanel,
  SignUpLogInPanel,
  UserSuggestionsPanel,
  LinkFooter,
  GabAdTopPanel,
  GabAdBottomPanel,
} from '../features/ui/util/async_components'
import { connect } from 'react-redux'
import HomeCallToAction from '../components/home_call_to_action'

class ExploreLayout extends ImmutablePureComponent {

  render() {
    const { children, width, noRightSidebar } = this.props

    const layout = [
      SignUpLogInPanel,
      <WrappedBundle key='explore-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'explore.sidebar', position: 1 }} />,
      <WrappedBundle key='explore-layout-link-footer' component={LinkFooter} />,
      <WrappedBundle key='home-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'explore.sidebar', position: 1 }} />,
    ].filter(Boolean)

    const tabs = [
      {
        title: 'Explore',
        to: !!me ? '/explore' : '/',
      },
      {
        title: 'PRO Feed',
        to: '/timeline/pro',
      },
      {
        title: 'Gab TV',
        to: '/timeline/videos',
      },
      {
        title: 'Clips',
        to: '/timeline/clips',
      },
      {
        title: 'Photos',
        to: '/timeline/photos',
      },
      {
        title: 'Polls',
        to: '/timeline/polls',
      },
    ]
  
    const isXS = width <= BREAKPOINT_EXTRA_SMALL
    const isSmall = !isXS && width <= BREAKPOINT_SMALL
    const isMD = !isSmall && !isXS && width <= BREAKPOINT_MEDIUM
    const isLarge = width >= BREAKPOINT_MEDIUM

    const leftLayout = [
      <WrappedBundle key='explore-layout-groups-panel' component={GroupsPanel} componentParams={{ groupType: 'featured', noPanel: 1, max: 6, padded: 1 }} />,
      <WrappedBundle key='explore-layout-user-suggestions-panel' component={UserSuggestionsPanel} componentParams={{ suggestionType: 'verified', noPanel: 1, padded: 1 }} />,
    ]
    const sidebarLayout = <SidebarPanelGroup layout={leftLayout} />
    
    const mainBlockClasses = CX({
      d: 1,
      w100PC: 1,
      pt15: 1,
      px15: !isMD,
    })

    const sidebarClasses = CX({
      d: 1,
      w340PX: 1,
      // pr15: isLarge,
      pl10: isLarge,
      pr10: !isLarge,
    })

    return (
      <Layout
        showGlobalFooter
        noRightSidebar
        showLinkFooterInSidebar
        noComposeButton
        page='explore'
        title='Explore'
        tabs={isXS ? undefined : tabs}
        sidebarChildren={sidebarLayout}
      >
        {
          isXS &&
          <div className={[_s.d, _s.w100PC].join(' ')}>
            <div className={[_s.d, _s.w100PC, _s.z1, _s.pt10].join(' ')}>
              <HomeCallToAction isXS={isXS} />
              <br />

              {
                !me &&
                <div className={[_s.d, _s.mt15, _s.px10].join(' ')}>
                  <WrappedBundle component={SignUpLogInPanel} componentParams={{ isXS: true }} />
                </div>
              }
              {children}
            </div>
          </div>
        }

        {
          !isXS &&
          <div className={mainBlockClasses}>
            <div className={[_s.d, _s.flexRow, _s.w100PC, _s.jcEnd].join(' ')}>
              
              { 
                noRightSidebar && children
              }

              {
                !noRightSidebar &&
                <div className={[_s.d, _s.mlAuto, _s.mrAuto, _s.w645PX, _s.z1].join(' ')}>
                  <HomeCallToAction isXS={isXS} />
                  {children}
                </div>
              }
              {
                !noRightSidebar && !isSmall && !isXS &&
                <div className={[_s.d, _s.w340PX].join(' ')}>
                  <Sticky top={73} enabled>
                    <div className={sidebarClasses}>
                      <SidebarPanelGroup page='explore' layout={layout} />
                    </div>
                  </Sticky>
                </div>
              }
            </div>
          </div>
        }
      </Layout>
    )
  }

}

const mapStateToProps = (state) => ({
  width: state.getIn(['settings', 'window_dimensions', 'width'])
})

ExploreLayout.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.node,
  group: ImmutablePropTypes.map,
  groupId: PropTypes.string,
  layout: PropTypes.object,
  relationships: ImmutablePropTypes.map,
  title: PropTypes.string,
  noRightSidebar: PropTypes.bool,
}

export default connect(mapStateToProps)(ExploreLayout)
